{
  "login": "login",
  "sign-up": "sign-up",
  "sidebar": "sidebar",
  "role": "role",
  "user": "user",
  "department": "department",
  "purchase-master": "purchase-master",
  "approvals": "approvals",
  "event-overview": "event-overview",
  "vendor": "vendor",
  "item-library": "item-library",
  "cms": "cms",
  "faq": "faq",
  "fp": "forgot-password",
  "profile": "my-profile",
  "data_analytics": "data-analytics",
  "reset-password": "reset-password",
  "otp-sent": "otp-sent",
  "otp-verification": "otp-verification",
  "password-set": "password-set",
  "template-builder": "template-builder",
  "form-builder": "form-builder",
  "uom": "uom",
  "attribute": "attribute",
  "attribute-value": "attribute-value",
  "support": "support",
  "category": "category",
  "currency": "currency",
  "location-master": "location-master",
  "city-master": "city-master",
  "country-master": "country-master",
  "state-master": "state-master",
  "notification": "notification",
  "dashboard": "dashboard",
  "system-preferences": "system-preferences",
  "contracts": "contracts",
  "fiscal-year-master": "fiscal-year-master",
  "fast-catalogue": "fast-catalogue"
}
